import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "iconMenu", "iconClose"]

  toggle() {
    this.panelTarget.classList.toggle("hidden")
    this.iconMenuTarget.classList.toggle("hidden")
    this.iconCloseTarget.classList.toggle("hidden")
  }
}
